import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable()
export class L10nTranslationsService {

  private readonly translations = new BehaviorSubject<Record<string, string>>({});

  public getL10nTranslations$(): Observable<Record<string, string>> {
    return this.translations.asObservable();
  }

  public setL10nTranslations(translations: Record<string, string>): void {
    this.translations.next(translations);
  }

}

